// extracted by mini-css-extract-plugin
module.exports = {"box":"resultbox_box__1bf15","table":"resultbox_table__1-I4F"};